import { Injectable } from '@angular/core';
import { TenantSettings } from '../../tenants/contracts/tenant_settings.interface';
import {RoleEnum} from '../contracts/role.interface';

@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  private readonly STORAGE_KEY = 'tenantSettings';
  private readonly ROLE_KEY = 'role';

  constructor() {}

  getTenantSettings(): TenantSettings | null {
    const role = localStorage.getItem(this.ROLE_KEY);

    if (role === RoleEnum.ADMIN) {
      return null;
    }

    const raw = localStorage.getItem(this.STORAGE_KEY);
    if (!raw) {
      return {};
    }

    try {
      return JSON.parse(raw) as TenantSettings;
    } catch (e) {
      console.error('Failed to parse tenantSettings:', e);
      return {};
    }
  }
}
